import { useState } from "react"
import {
	IconCheckOutline18 as Check,
	IconCopyOutline18 as CopyIcon,
} from "nucleo-ui-outline-18"
import { useCopyToClipboard, useDebounce } from "react-use"

import type { SidebarSectionCopyFieldComponent } from "@productlane/api/src/browser"
import { Tooltip } from "@productlane/ui"

interface Props {
	component: SidebarSectionCopyFieldComponent
}

export function CopyFieldComponent({ component }: Props) {
	const [, copy] = useCopyToClipboard()
	const [isCopied, setIsCopied] = useState(false)
	useDebounce(
		() => {
			setIsCopied(false)
		},
		1000,
		[isCopied],
	)
	return (
		<Tooltip label={component.tooltip ?? component.value}>
			{/* max-w allows for the negative margin, else the right overhang is
			dropped and the icon lands short of the column's right axis. */}
			<button
				type="button"
				onClick={() => {
					copy(component.value)
					setIsCopied(true)
				}}
				className="-mx-1.5 flex h-6 max-w-[calc(100%+0.75rem)] cursor-default select-none items-center gap-1.5 rounded-md px-1.5 hover:bg-gray-150 dark:hover:bg-gray-800"
			>
				<span className="truncate font-mono text-[11px] text-secondary">
					{component.value}
				</span>
				{isCopied ? (
					<Check
						strokeWidth={1.75}
						className="h-3.5 w-3.5 flex-none text-green-500"
					/>
				) : (
					<CopyIcon
						strokeWidth={1.75}
						className="h-3.5 w-3.5 flex-none text-tertiary"
					/>
				)}
			</button>
		</Tooltip>
	)
}
